import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=23fd3a76&scoped=true"
import script from "./Waiting.vue?vue&type=script&lang=js"
export * from "./Waiting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fd3a76",
  null
  
)

export default component.exports